import { Box, useTheme } from "@mui/material";
import { Business } from "lib/features/business/types";
import { editBusinessProfileStyles } from "styles/BusinessDirectory/editBusinessProfile.styles";
import EditBusinessForm from "./EditBusinessForm";
import EditBusinessHeader from "./EditBusinessHeader";

type EditBusinessProfileProps = {
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  businessDetails: Business;
  refetch: any;
};

const EditBusinessProfile = ({
  setIsEditing,
  businessDetails,
  refetch,
}: EditBusinessProfileProps) => {
  const theme = useTheme();
  return (
    <Box sx={editBusinessProfileStyles.mainContainer(theme)}>
      {/* Header */}
      <EditBusinessHeader setIsEditing={setIsEditing} />

      {/* Form */}
      <EditBusinessForm
        businessDetails={businessDetails}
        refetch={refetch}
        setIsEditing={setIsEditing}
      />
    </Box>
  );
};

export default EditBusinessProfile;
